import { Month } from '../types';
import { shift } from '../../utils';

export enum WeekdayKey {
  SUN = 'sun',
  MON = 'mon',
  TUE = 'tue',
  WED = 'wed',
  THU = 'thu',
  FRI = 'fri',
  SAT = 'sat',
}

export interface Calendar {
  months: Month[];
  numberOfDays: number;
  weekStartsOn: WeekdayKey;
  weekdayKeys: WeekdayKey[];
}

export const WEEKDAYS: ReadonlyArray<WeekdayKey> = Object.freeze([
  WeekdayKey.SUN,
  WeekdayKey.MON,
  WeekdayKey.TUE,
  WeekdayKey.WED,
  WeekdayKey.THU,
  WeekdayKey.FRI,
  WeekdayKey.SAT,
]);

export const WEEKDAYS_FROM_MON: ReadonlyArray<WeekdayKey> = Object.freeze(shift([...WEEKDAYS], 1));

export enum MonthKey {
  JAN = 'jan',
  FEB = 'feb',
  MAR = 'mar',
  APR = 'apr',
  MAY = 'may',
  JUNE = 'june',
  JULY = 'july',
  AUG = 'aug',
  SEPT = 'sept',
  OCT = 'oct',
  NOV = 'nov',
  DEC = 'dec',
}

export const MONTHS: ReadonlyArray<MonthKey> = Object.freeze([
  MonthKey.JAN,
  MonthKey.FEB,
  MonthKey.MAR,
  MonthKey.APR,
  MonthKey.MAY,
  MonthKey.JUNE,
  MonthKey.JULY,
  MonthKey.AUG,
  MonthKey.SEPT,
  MonthKey.OCT,
  MonthKey.NOV,
  MonthKey.DEC,
]);
